import { useSyncExternalStore } from "react";
import { isFramed } from "@/shared/frame";

/** Below this window width, in CSS px, the forms give way to the notice. */
export const SMALL_SCREEN_BREAKPOINT = 768;

// The Media Queries Level 3 form on purpose: older Safari cannot parse the
// range form `(width < …)`, and a query it cannot parse never matches, which
// would show the forms.
export const SMALL_SCREEN_QUERY = `not all and (min-width: ${SMALL_SCREEN_BREAKPOINT}px)`;

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(SMALL_SCREEN_QUERY);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

function isSmallScreen(): boolean {
  return window.matchMedia(SMALL_SCREEN_QUERY).matches;
}

/**
 * Whether a sign-in or password form gives way to `SmallScreenNotice`: the
 * window is narrower than `SMALL_SCREEN_BREAKPOINT` and the page is not
 * framed. Framed, the page is IAP's session refresher (`src/shared/frame.ts`),
 * which must keep working at any size.
 */
export function useSmallScreenNotice(): boolean {
  const smallScreen = useSyncExternalStore(subscribe, isSmallScreen);
  return smallScreen && !isFramed();
}
